function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { PlayerState } from '../../core/player/player-state';
var ShakaStateMachine = /*#__PURE__*/ function() {
    "use strict";
    function ShakaStateMachine(onStateChange, isAttemptingInternalRetry) {
        var _this = this;
        _class_call_check(this, ShakaStateMachine);
        _define_property(this, "isAttemptingInternalRetry", void 0);
        _define_property(this, "outputStateChanged", void 0);
        _define_property(this, "preSeekPlaybackState", void 0);
        _define_property(this, "lastKnownOutputState", void 0);
        _define_property(this, "seeking", void 0);
        this.isAttemptingInternalRetry = isAttemptingInternalRetry;
        this.preSeekPlaybackState = null;
        this.lastKnownOutputState = null;
        this.seeking = false;
        this.outputStateChanged = function(state) {
            onStateChange(state);
            _this.lastKnownOutputState = state;
        };
    }
    _create_class(ShakaStateMachine, [
        {
            key: "inputStateChange",
            value: function inputStateChange(playerState) {
                switch(playerState){
                    case PlayerState.Playing:
                    case PlayerState.Paused:
                        this.isAttemptingInternalRetry = false;
                        this.preSeekPlaybackState = playerState;
                        if (!this.seeking) {
                            this.outputStateChanged(playerState);
                        }
                        break;
                    case PlayerState.Rebuffering:
                        if (!this.seeking && this.lastKnownOutputState !== PlayerState.Loading) {
                            this.outputStateChanged(playerState);
                        }
                        break;
                    case PlayerState.Loading:
                        this.seeking = false;
                        if (this.isAttemptingInternalRetry) {
                            this.outputStateChanged(PlayerState.Rebuffering);
                            break;
                        }
                        this.outputStateChanged(playerState);
                        break;
                    case PlayerState.Stopped:
                    case PlayerState.Finished:
                        this.seeking = false;
                        this.outputStateChanged(playerState);
                        break;
                    case PlayerState.Seeking:
                        if (!this.seeking) {
                            this.seeking = true;
                            if (this.lastKnownOutputState !== PlayerState.Loading) {
                                this.outputStateChanged(PlayerState.Seeking);
                            }
                        }
                        break;
                }
            }
        },
        {
            key: "endSeek",
            value: function endSeek() {
                if (!this.seeking) {
                    return;
                }
                this.seeking = false;
                if (this.preSeekPlaybackState) {
                    this.outputStateChanged(this.preSeekPlaybackState);
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.seeking = false;
                this.inputStateChange(PlayerState.Stopped);
            }
        }
    ]);
    return ShakaStateMachine;
}();
export var ShakaStateMachineManager = /*#__PURE__*/ function() {
    "use strict";
    function ShakaStateMachineManager(autoplay, onStateChange, isAttemptingInternalRetry) {
        var _this = this;
        _class_call_check(this, ShakaStateMachineManager);
        _define_property(this, "autoplay", void 0);
        _define_property(this, "stateMachine", void 0);
        _define_property(this, "setLoading", void 0);
        _define_property(this, "setRebuffering", void 0);
        _define_property(this, "setPaused", void 0);
        _define_property(this, "setFinished", void 0);
        _define_property(this, "setPlaying", void 0);
        _define_property(this, "setSeeking", void 0);
        _define_property(this, "setSeekEnded", void 0);
        _define_property(this, "setCanPlayThrough", void 0);
        this.autoplay = autoplay;
        this.stateMachine = null;
        this.setLoading = function() {
            _this.inputStateChange(PlayerState.Loading);
        };
        this.setRebuffering = function() {
            _this.inputStateChange(PlayerState.Rebuffering);
        };
        this.setPaused = function() {
            _this.inputStateChange(PlayerState.Paused);
        };
        this.setFinished = function() {
            _this.inputStateChange(PlayerState.Finished);
        };
        this.setPlaying = function() {
            _this.inputStateChange(PlayerState.Playing);
        };
        this.setSeeking = function() {
            return _this.inputStateChange(PlayerState.Seeking);
        };
        this.setSeekEnded = function() {
            var _this_stateMachine;
            return (_this_stateMachine = _this.stateMachine) === null || _this_stateMachine === void 0 ? void 0 : _this_stateMachine.endSeek();
        };
        this.setCanPlayThrough = function(isVidElementPaused) {
            if (isVidElementPaused || !_this.autoplay) {
                var _this_stateMachine;
                (_this_stateMachine = _this.stateMachine) === null || _this_stateMachine === void 0 ? void 0 : _this_stateMachine.endSeek();
                _this.inputStateChange(PlayerState.Paused);
            }
        };
        this.stateMachine = new ShakaStateMachine(onStateChange, isAttemptingInternalRetry);
    }
    _create_class(ShakaStateMachineManager, [
        {
            key: "destroy",
            value: function destroy(silently) {
                if (!silently) {
                    var _this_stateMachine;
                    (_this_stateMachine = this.stateMachine) === null || _this_stateMachine === void 0 ? void 0 : _this_stateMachine.stop();
                }
                this.stateMachine = null;
            }
        },
        {
            key: "inputStateChange",
            value: function inputStateChange(shakaInput) {
                var _this_stateMachine;
                (_this_stateMachine = this.stateMachine) === null || _this_stateMachine === void 0 ? void 0 : _this_stateMachine.inputStateChange(shakaInput);
            }
        }
    ]);
    return ShakaStateMachineManager;
}();

//# sourceMappingURL=shaka-state-machine.js.map